import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

export default function LoanApplicationView() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [imageError, setImageError] = useState(false);
  const location = useLocation();
  const extraProps = location.state || {};

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/loan-application/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  }, [id]);

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header Section with Card Shadow */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
                <div className="content-page-header content-page-headersplit">
              <h5>View Loan Application</h5>
              <div className="list-btn">
                <Link to="/loan-application" className="btn btn-cancel">
                  <i className="fas fa-arrow-left me-2"></i>
                  Back
                </Link>
              </div>
            </div>
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link> /
                </li>
                <li className="breadcrumb-item">
                  <Link to="/loan-application">Loan Applications</Link> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  View Loan Application
                </li>
              </ol>
            </nav>
        
          </div>

          {/* Profile Header Section with Card Shadow */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-4 text-center mb-3 mb-md-0">
                <div
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    margin: "0 auto",
                    background: "#f9fafb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "3px solid #e6f6f5",
                  }}
                >
                  {data?.user_photo && !imageError ? (
                    <img
                      src={`${process.env.REACT_APP_BACKEND_BASE_URL_FILES}${data.user_photo}`}
                      alt="Applicant"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={() => setImageError(true)}
                    />
                  ) : (
                    <i
                      className="fas fa-user"
                      style={{ fontSize: "60px", color: "#006e82" }}
                    ></i>
                  )}
                </div>
              </div>
              <div className="col-lg-9 col-md-8">
                <h4 style={{ marginBottom: "8px", fontWeight: 600, color: "#006e82" }}>
                  {data.user_first_name} {data.user_last_name}
                </h4>
                <p style={{ marginBottom: "4px", color: "#666", fontSize: "14px" }}>
                  <i className="fas fa-envelope me-2" style={{ color: "#006e82" }}></i>
                  {data.user_email || "-"}
                </p>
                {data.user_phone && (
                  <p style={{ marginBottom: "0", color: "#666", fontSize: "14px" }}>
                    <i className="fas fa-phone me-2" style={{ color: "#006e82" }}></i>
                    {data.country_code} {data.user_phone}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Personal Details Section with Card Shadow */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <h4
              style={{
                marginBottom: "20px",
                borderBottom: "2px solid #e6f6f5",
                paddingBottom: "12px",
                fontSize: "20px",
                fontWeight: 600,
                color: "#006e82",
              }}
            >
              Personal Details
            </h4>
            <div className="row g-3">
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    First Name
                  </label>
                  <input
                    type="text"
                    value={data.user_first_name || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Last Name
                  </label>
                  <input
                    type="text"
                    value={data.user_last_name || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Email
                  </label>
                  <input
                    type="email"
                    value={data.user_email || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Phone
                  </label>
                  <input
                    type="text"
                    value={
                      data.country_code && data.user_phone
                        ? `${data.country_code} ${data.user_phone}`
                        : ""
                    }
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    PAN Number
                  </label>
                  <input
                    type="text"
                    value={data.user_pan || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Application Details Section with Card Shadow */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <h4
              style={{
                marginBottom: "20px",
                borderBottom: "2px solid #e6f6f5",
                paddingBottom: "12px",
                fontSize: "20px",
                fontWeight: 600,
                color: "#006e82",
              }}
            >
              Application Details
            </h4>
            <div className="row g-3">
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Application Code
                  </label>
                  <input
                    type="text"
                    value={data.application_code || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Application Date
                  </label>
                  <input
                    type="text"
                    value={
                      data.application_date
                        ? data.application_date.split("T")[0]
                        : ""
                    }
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Loan Type
                  </label>
                  <input
                    type="text"
                    value={data.loan_type || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Loan Category
                  </label>
                  <input
                    type="text"
                    value={data.loan_category || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Business Activity
                  </label>
                  <input
                    type="text"
                    value={data.business_activity || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Profession
                  </label>
                  <input
                    type="text"
                    value={data.profession || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Industry
                  </label>
                  <input
                    type="text"
                    value={data.industry || ""}
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Loan Amount
                  </label>
                  <input
                    type="text"
                    value={
                      data.loan_amount
                        ? `₹ ${Number(data.loan_amount).toLocaleString("en-IN")}`
                        : ""
                    }
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                    Market Value
                  </label>
                  <input
                    type="text"
                    value={
                      data.market_value
                        ? `₹ ${Number(data.market_value).toLocaleString("en-IN")}`
                        : ""
                    }
                    disabled
                    className="form-control"
                    style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
